import { render } from "./MdlAsignarClienteWhatsapp.vue?vue&type=template&id=643c9d48&scoped=true"
import script from "./MdlAsignarClienteWhatsapp.vue?vue&type=script&lang=js"
export * from "./MdlAsignarClienteWhatsapp.vue?vue&type=script&lang=js"

import "./MdlAsignarClienteWhatsapp.vue?vue&type=style&index=0&id=643c9d48&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-643c9d48"]])

export default __exports__